export const partners = [
  { name: "sa-logo.jpg", url: "https://southaustralia.com/" },
  { name: "ccf-logo.jpg", url: "https://ccfsa.com.au/" },
  { name: "actiond-logo.png", url: "https://actiond.io/" },
  { name: "Solvable.png", url: "https://www.solvable.com.au/" },
  { name: "Staffd.png", url: "https://staffd.me/" },
  { name: "tmaa-logo.jpg", url: "https://tmaa.asn.au/" },
  { name: "traffio.png", url: "https://www.traffio.com.au/" },
];
